import {PayloadAction, createSelector, createSlice} from '@reduxjs/toolkit';

import {HeatProfile} from '../../types';
import {ProfileStore, Store} from '../types';
import {currentDeviceHeatProfilesSelector} from './bleSlice';

const profileSlice = createSlice({
  name: 'profiles',
  initialState: {
    items: {},
  } as ProfileStore,
  reducers: {
    setAccountHeatProfiles(
      state: ProfileStore,
      action: PayloadAction<HeatProfile[]>,
    ) {
      const items = Object.fromEntries(action.payload.map(p => [p.id, p]));

      state.items = {...items};
    },
    upsertAccountHeatProfiles(
      state: ProfileStore,
      action: PayloadAction<HeatProfile[]>,
    ) {
      const items = Object.fromEntries(action.payload.map(p => [p.id, p]));

      state.items = {...state.items, ...items};
    },
    deleteAccountHeatProfile(
      state: ProfileStore,
      action: PayloadAction<string>,
    ) {
      delete state.items[action.payload];
    },
    clearAccountHeatProfiles(state: ProfileStore) {
      state.items = {};
    },
  },
});

export const heatProfilesMapSelector = (state: Store) => state.profile.items;
export const heatProfilesListSelector = createSelector(
  heatProfilesMapSelector,
  heatProfilesMap => Object.values(heatProfilesMap),
);

export const allHeatProfilesMapSelector = createSelector(
  currentDeviceHeatProfilesSelector,
  heatProfilesMapSelector,
  (currentDeviceHeatProfilesSelector, accountHeatProfilesMap) => {
    const deviceHeatProfilesMap = Object.fromEntries(
      currentDeviceHeatProfilesSelector.map(p => [p.id, p]),
    );

    return {...deviceHeatProfilesMap, ...accountHeatProfilesMap};
  },
);

export const accountHeatProfilesSelector = createSelector(
  heatProfilesListSelector,
  heatProfilesList => heatProfilesList,
);

export const {
  upsertAccountHeatProfiles,
  setAccountHeatProfiles,
  clearAccountHeatProfiles,
  deleteAccountHeatProfile,
} = profileSlice.actions;

export const profileReducer = profileSlice.reducer;
